import type { CreateFilterText } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

export const getFiltersFromUrl = (
	filterText: string | null | undefined
): CreateFilterText => {
	const result: CreateFilterText = {
		allParametrics: [],
		selectedFilters: {}
	};

	if (!filterText) {
		return result;
	}

	const filterGroups = filterText.split(";").filter(Boolean);
	filterGroups.forEach((group) => {
		const [type, values] = group.split("|") as [FilterTypes, string];

		if (!type || !values) return;

		switch (type) {
			case FilterTypes.PARAMETRIC: {
				const parametricFilters = (result.selectedFilters[
					FilterTypes.PARAMETRIC
				] ??= {});
				const addParametricValue = (paramId: number, filterId: number) => {
					const selectedValues = (parametricFilters[paramId] ??= []);
					if (!selectedValues.includes(filterId)) {
						selectedValues.push(filterId);
					}
				};

				const valueList = values.split("*");
				valueList.forEach((value) => {
					// A boolean parametric (true only) is selected under a negative
					// value id; see booleanParametricFilter in norce-pwa.
					const booleanParametricId = parseBooleanParametricFilterText(value);
					if (booleanParametricId !== undefined) {
						addParametricValue(
							booleanParametricId,
							booleanParametricValueId(booleanParametricId)
						);
						return;
					}

					const match = value.match(/^[LM](\d+)_(\d+)$/);
					if (match) {
						const [, parametricId, id] = match;

						if (parametricId && id) {
							addParametricValue(parseInt(parametricId, 10), parseInt(id, 10));
						}
					}
				});
				break;
			}

			case FilterTypes.PRICE: {
				const match = values.match(/^true_(\d+)-(\d+)$/);
				if (match) {
					const [, min, max] = match;

					if (min && max) {
						result.selectedFilters[FilterTypes.PRICE] = [
							parseInt(min, 10),
							parseInt(max, 10)
						];
					}
				}
				break;
			}

			case FilterTypes.CATEGORY:
			case FilterTypes.MANUFACTURER:
			case FilterTypes.ONHAND:
			case FilterTypes.FLAG: {
				const ids = values
					.split(",")
					.map((id) => parseInt(id.trim(), 10))
					.filter((id) => !isNaN(id));

				if (ids.length > 0) {
					result.selectedFilters[type] = ids;
				}
				break;
			}

			default:
				console.warn(`Unknown filter type: ${type}`);
				break;
		}
	});

	return result;
};
